// Shared by SocialRow (icon-only) and CandidateProfilePanel's Contact list
// (full row with visible URL) — both need to normalize a raw social/contact
// URL into a clickable href and a readable label.
export const toHref = (url) => (url.startsWith("http") ? url : `https://${url}`);
export const stripProtocol = (url) => url.replace(/^https?:\/\/(www\.)?/i, "");
